import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css";

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        role: "",
        company: "",
        country: "",
        what: "",
        email: "",
    });

    const [isSubmitted, setIsSubmitted] = useState(false); // Track submission

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();


        emailjs
            .send(
                "service_m4yn1ln",
                "template_w1r0w4d",
                {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    role: formData.role,
                    company: formData.company,
                    country: formData.country,
                    what: formData.what,
                    email: formData.email,
                },
                "KuAjCm1HkgLWtd8hV"
            )
            .then(
                (response) => {
                    console.log("SUCCESS!", response.status, response.text);
                    setIsSubmitted(true);
                },
                (error) => {
                    console.error("FAILED...", error);
                    alert("Oops! Something went wrong. Please try again.");
                }
            );

        // Reset form
        setFormData({
            firstName: "",
            lastName: "",
            role: "",
            company: "",
            country: "",
            what: "",
            email: "",
        });
    };

    return (
        <div>
            <div className={"contact-big"}>
                <div className="contact-page">
                    <div className="contact-header">
                        <h1>Let's Talk!</h1>
                        <p>
                            Have a business need or an RFP to submit? Interested in discussing your company's growth prospects? Provide your contact information and we'll put you in touch with the appropriate expert.
                        </p>
                    </div>
                    {isSubmitted ? (
                        <p>Thank you for reaching out! We'll get back to you soon.</p>
                    ) : (
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <p>
                                Hey, my name is{" "}
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                />
                                {" "}
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                />
                                . I’m a{" "}
                                <input
                                    type="text"
                                    name="role"
                                    placeholder="Role"
                                    value={formData.role}
                                    onChange={handleChange}
                                    required
                                />
                                {" "}at{" "}
                                <input
                                    type="text"
                                    name="company"
                                    placeholder="Company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required
                                />
                                , located in{" "}
                                <input
                                    type="text"
                                    name="country"
                                    placeholder="Country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    required
                                />
                                and I need help with
                                <input
                                    type="text"
                                    name="what"
                                    placeholder="How can we help?"
                                    value={formData.what}
                                    onChange={handleChange}
                                    required
                                />
                                . You can reach me at{" "}
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                .
                            </p>
                            <button type="submit" className="btn-submit">Submit</button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Contact;
